<template>
  <div
    ref="imageBackground"
    class="message-image"
    :class="componentClass"
    :style="{'background-image': `url('${message.file.url}?size=small')`, 'item-clickable': message.media && !message.media.is_blurred}"
    :data-mfp-src="message.file.url+'?p=big'"
  >
    <div v-if="message.media && message.media.is_blurred" class="image-price">{{ message.media.price }} <i class="demo-icon icon-n-lova-coins"></i></div>
    <transition name="fade-image">
      <div class="image-buttons">
        <div v-if="message.media && message.media.is_blurred">
          <button class="button button--tight button__outline button__outline--white-hov-white" @click.stop="emitBuyMedia(message)">{{ trans.get('pages:chat.img_click_to_view') }}</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'ChatImage',
  components: {},
  props: {
    message: {},
    imageHover: {},
    isImageLoading: {},
  },
  data() {
    return {};
  },
  computed: {
    componentClass() {
      return {
        'image-loading': this.isImageLoading,
        'image-media': this.message.media,
        'image-gift': this.message.gift,
        'image-blurred': this.message.media && this.message.media.is_blurred,
      };
    }
  },
  methods: {
    emitBuyMedia(message) {
      this.$emit('buyMedia', { media: message.media, message: message });
    },
  },
  watch: {},
  mounted() {
    if (this.message.media)
      $(this.$refs.imageBackground).magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-img-mobile',
        image: {
          verticalFit: true
        }
      });
  }
};
</script>
